import accountApi from 'api/accountApi';
import maintainerApi from 'api/maintainerApi';
import store from 'app/store';
import AuthHelper from 'features/Auth/authHelper';
import { setAgencyRoleList, setPermissionList, updateUser } from 'features/Auth/authSlice';
import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';

const AccountHelper = {
  // ---- methods ----
  callApiGetProfile: async () => {
    try {
      const savedActiveRole = localStorage.getItem(PreferenceKeys.savedActiveRole);
      let res;
      if (savedActiveRole === AppConstants.userRole.maintainer) {
        res = await maintainerApi.getProfile();
      } else {
        res = await accountApi.getProfile();
      }
      const { result, profile } = res;
      if (result == 'success') {
        store.dispatch(updateUser(profile));
        if (profile?.role === AppConstants.userRole.agency && !_.isUndefined(profile.agency)) {
          if (profile.agency?.primaryRole !== 'VOUCHER_PARTNER') {
            const agencyRoleList = [
              ...new Set(
                profile?.agency?.commissions?.map((commission) => ({
                  role: commission.role,
                  commissionId: commission.commissionId
                })) || []
              )
            ];

            agencyRoleList.sort((a, b) => a.commissionId - b.commissionId);

            const formatAgencyRoleList = [...new Set(agencyRoleList.map(item => item.role))];
            store.dispatch(setAgencyRoleList(formatAgencyRoleList));
          } else {
            store.dispatch(setAgencyRoleList(['VOUCHER_PARTNER']));
          }
        }

        const permissionList = profile?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        });
        store.dispatch(setPermissionList(permissionList));
      }
    } catch (error) {
      const statusCode = error?.response?.status;
      if (statusCode == 401 || statusCode == 403) {
        ToastHelper.showError(t('message401error'));
        AuthHelper.signOut();
        Utils.openInCurrentTab(AppRoute.auth);
      }
    }
  },

  checkAccountPermission: (permissionCode, permissionList) => {
    if (!permissionList || !Array.isArray(permissionList) || permissionList.length === 0) {
      return true;
    }

    return permissionList.some((permission) => permission?.code === permissionCode);
  },

  callApiUpdateUser: async (userId, params) => {
    try {
      const res = await accountApi.updateUser(userId, params);
      const { result } = res;
      return result === 'success';
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },
};

export default AccountHelper;
